module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', [_vm._v("Edit Post")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "form1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save()
      }
    }
  }, [_c('table', [_c('tr', [_c('td', [_vm._v("\n              Category:\n            ")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cat),
      expression: "cat"
    }],
    attrs: {
      "name": "categorydropdown"
    },
    on: {
      "change": function($event) {
        _vm.cat = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.categories), function(c) {
    return _c('option', {
      key: c.id,
      domProps: {
        "value": c
      }
    }, [_vm._v("\n                  " + _vm._s(c.category) + "\n                ")])
  }))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Title:\n            ")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.title),
      expression: "post.title"
    }],
    attrs: {
      "type": "text",
      "name": "title",
      "size": "66",
      "maxlength": "100"
    },
    domProps: {
      "value": _vm._s(_vm.post.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n              Content:\n            ")]), _vm._v(" "), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.content),
      expression: "post.content"
    }],
    attrs: {
      "name": "content",
      "cols": "50",
      "rows": "20"
    },
    domProps: {
      "value": _vm._s(_vm.post.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.content = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('input', {
    attrs: {
      "type": "submit",
      "name": "submit",
      "value": "Submit Post"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0bfb8d84!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/EditPost.vue
// module id = 482
// module chunks = 1